import Rest from 'services/data/rest';
import File from 'services/data/file';
import axios from 'axios';
import Promise from 'bluebird';

// Actions
import { alerts } from 'modules/alerts/actions';
import * as pageData from 'modules/page-data/actions';


export default class Settings extends Rest {
  static path = 'settings';
  static defaultQuery = {};

  static initializeSocket() {
    return Settings.find()
      .then(settings => {
        pageData.update('settings', settings);

        if (settings.templateFolder) {
          return File.list(settings.templateFolder, { params: { rawDrive: true } })
            .then(items => {
              pageData.update('templateFiles', items);
            });
        }
      })
      .catch(alerts.catchError);
  }

  static update(settings) {
    return Promise.resolve(axios.put('/api/settings', settings))
      .tap(this.logRequest)
      .then((response) => response.data);
  }

  static testNotification(data) {
    return Promise.resolve(axios.post('/api/settings/test-notification', data))
      .tap(this.logRequest)
      .then((response) => response.data);
  }

  static syncContacts(data) {
    return Promise.resolve(axios.post('/api/settings/sync-contacts', data))
      .tap(this.logRequest)
      .then((response) => response.data);
  }
}



// WEBPACK FOOTER //
// ./app/services/data/settings.js